import React, { useState, useEffect, useCallback } from 'react';
import CountUpPkg from 'react-countup';
const CountUp = CountUpPkg.default || CountUpPkg;
import { FiFileText, FiX } from 'react-icons/fi';
import quotesData from '../data/quotes.json';
import BookCVModal from './BookCVModal';
import './Hero.css';

const Hero = () => {
  const [showCV, setShowCV] = useState(false);
  const [showPhoto, setShowPhoto] = useState(false);
  const [currentQuote, setCurrentQuote] = useState(null);
  const [displayedQuoteText, setDisplayedQuoteText] = useState('');
  const [pdfWidth, setPdfWidth] = useState(800);

  useEffect(() => {
    if (showPhoto && currentQuote) {
      let index = 0;
      setDisplayedQuoteText('');
      const timer = setInterval(() => {
        if (index < currentQuote.text.length) {
          setDisplayedQuoteText(currentQuote.text.substring(0, index + 1));
          index++;
        } else {
          clearInterval(timer);
        }
      }, 30);
      return () => clearInterval(timer);
    }
  }, [showPhoto, currentQuote]);

  useEffect(() => {
    const handleResize = () => {
      setPdfWidth(Math.min(window.innerWidth * 0.9, 800));
    };
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const openCV = (e) => {
    e.preventDefault();
    setShowCV(true);
    document.body.style.overflow = 'hidden';
  };

  const closeCV = useCallback(() => {
    setShowCV(false);
    document.body.style.overflow = '';
  }, []);

  const openPhoto = () => {
    const randomQuote = quotesData[Math.floor(Math.random() * quotesData.length)];
    setCurrentQuote(randomQuote);
    setShowPhoto(true);
    document.body.style.overflow = 'hidden';
  };

  const closePhoto = useCallback(() => {
    setShowPhoto(false);
    document.body.style.overflow = '';
  }, []);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        closeCV();
        closePhoto();
      }
    };
    if (showCV || showPhoto) {
      document.addEventListener('keydown', handleEsc);
    }
    return () => document.removeEventListener('keydown', handleEsc);
  }, [showCV, closeCV, showPhoto, closePhoto]);

  return (
    <div id="hero">
      <div className="hero-ticker" aria-hidden="true">
        <div className="ticker-track">
          <span className="ticker-item">JUNIOR SOFTWARE ENGINEER @ WECONN3CT GMBH</span><span className="ticker-sep">✦</span>
          <span className="ticker-item">FULL STACK DEVELOPER</span><span className="ticker-sep">✦</span>
          <span className="ticker-item">MERN · LARAVEL · FASTAPI · MICROSERVICES</span><span className="ticker-sep">✦</span>
          <span className="ticker-item">GERMANY · REMOTE</span><span className="ticker-sep">✦</span>
          <span className="ticker-item">BSc SOFTWARE ENGINEERING · SLIIT</span><span className="ticker-sep">✦</span>
          <span className="ticker-item">JUNIOR SOFTWARE ENGINEER @ WECONN3CT GMBH</span><span className="ticker-sep">✦</span>
          <span className="ticker-item">FULL STACK DEVELOPER</span><span className="ticker-sep">✦</span>
          <span className="ticker-item">MERN · LARAVEL · FASTAPI · MICROSERVICES</span><span className="ticker-sep">✦</span>
          <span className="ticker-item">GERMANY · REMOTE</span><span className="ticker-sep">✦</span>
          <span className="ticker-item">BSc SOFTWARE ENGINEERING · SLIIT</span><span className="ticker-sep">✦</span>
        </div>
      </div>

      <div className="hero-main">
        <div className="hero-left">
          <div>
            {/* H1 visible to crawlers — primary name + roles (SEO requirement) */}
            <h1 className="seo-h1">Marisilin Bijosilin (Bijon) — Full Stack Developer &amp; ML Researcher</h1>
            <div className="hero-eyebrow">Junior Software Engineer @ WECONN3CT GmbH</div>
            <div className="hero-name-block">
              <img
                src="/images/final.png"
                alt="Marisilin Bijosilin, Junior Software Engineer, WECONN3CT GmbH"
                className="hero-profile-img"
                loading="eager"
                fetchPriority="high"
                width="140"
                height="140"
                onClick={openPhoto}
                style={{ cursor: 'pointer' }}
              />
              <div>
                <span className="hero-first">MARISILIN</span>
                <span className="hero-last">BIJOSILIN</span>
              </div>
            </div>
            <p className="hero-tagline">Junior Software Engineer at WECONN3CT GmbH (Germany · Remote) with production engineering experience across international enterprise products, government systems, and medical AI research.</p>
          </div>
          <div>
            <div className="hero-cta-row">
              <a href="#projects" className="btn-blk" aria-label="View Projects Built by Marisilin Bijosilin">View Work ↗</a>
              <a href="#contact" className="btn-ghost" aria-label="Contact Marisilin Bijosilin (Bijon)">Get in Touch</a>
              <a href="#" onClick={openCV} className="btn-ghost btn-cv" aria-label="View CV and Resume of Marisilin Bijosilin">
                <span className="cv-icon"><FiFileText /></span> View CV
              </a>
            </div>
          </div>
        </div>
        <div className="hero-right">
          <div className="hero-stat-box" data-num="10">
            <div className="hsb-num"><CountUp end={10} duration={2.5} enableScrollSpy scrollSpyOnce>10</CountUp><span>+</span></div>
            <div className="hsb-label">Projects Built</div>
            <div className="hsb-sub">From research to deployed apps</div>
            <p className="hsb-desc">Spanning MERN e-commerce, AI study companions, medical ML research, Android apps, hospital management, social platforms, and enterprise game systems — from concept to production.</p>
          </div>
          <div className="hero-stat-box" data-num="2">
            <div className="hsb-num"><CountUp end={2} duration={2.5} enableScrollSpy scrollSpyOnce>2</CountUp></div>
            <div className="hsb-label">Industry Internships</div>
            <div className="hsb-sub">FAITE · CodeVita</div>
            <p className="hsb-desc">Production experience with live government systems, AI marketing tools, classified ads platforms, POS systems, and NGO web applications across multiple tech stacks.</p>
          </div>
        </div>
      </div>

      <div className="hero-bottom">
        <div className="hb-item">Location<strong>Jaffna, Sri Lanka</strong></div>
        <div className="hb-item">University<strong>SLIIT · BSc (Hons) SE</strong></div>
        <div className="hb-item">Research<strong>ECG Arrhythmia Detection</strong></div>
        <div className="hb-item">Degree<strong>First Class (2026)</strong></div>
      </div>

      {/* 3D Book CV Preview Modal */}
      <BookCVModal
        isOpen={showCV}
        onClose={closeCV}
        pdfUrl="/Marisilin_Bijosilin_Resume.pdf"
      />

      {/* Photo Modal */}
      {showPhoto && currentQuote && (
        <div className="cv-modal-overlay photo-overlay" onClick={closePhoto}>
          <div className="photo-modal-split" onClick={(e) => e.stopPropagation()}>
            <button className="quote-close-btn" onClick={closePhoto} title="Close (Esc)">✕</button>
            <div className="pm-left">
              <img src="/images/bijooonnn.png" alt="Marisilin Bijosilin (Bijon) — Junior Software Engineer &amp; ML Researcher" className="pm-img" />
            </div>
            <div className="pm-right">
              <div className="pm-quote-mark">“</div>
              <blockquote className="quote-text-small">
                {displayedQuoteText}
                <span className="cursor-blink">|</span>
              </blockquote>
              <div className="quote-author-small">— {currentQuote.author || 'Unknown'}</div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Hero;
